import {ValueObject} from '@s-ui/domain'

/**
 * https://schema.org/PostalAddress
 */
export class PostalAddressStructuredDataSeoValueObject extends ValueObject {
  #addressLocality
  #postalCode
  #streetAddress
  #type = 'PostalAddress'

  constructor({addressLocality, postalCode, streetAddress}) {
    super()
    this.#addressLocality = addressLocality
    this.#postalCode = postalCode
    this.#streetAddress = streetAddress
  }

  static createFromPrimitives({addressLocality, postalCode, streetAddress}) {
    return new PostalAddressStructuredDataSeoValueObject({addressLocality, postalCode, streetAddress})
  }

  get postalCode() {
    return this.#postalCode
  }

  get streetAddress() {
    return this.#streetAddress
  }

  get type() {
    return this.#type
  }

  get value() {
    return {
      '@type': this.#type,
      addressLocality: this.#addressLocality,
      postalCode: this.#postalCode,
      streetAddress: this.#streetAddress
    }
  }
}
